import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import CountryLookup from './pages/CountryLookup';
import RankingsPage from './pages/RankingsPage';
import MethodologyPage from './pages/MethodologyPage';
import SuggestDataPage from './pages/SuggestDataPage';
import SimulationPage from './pages/SimulationPage';
import './App.css';

function NavBar() {
  const location = useLocation();
  const isActive = (path) => location.pathname === path ? 'nav-link active' : 'nav-link';

  return (
    <nav className="main-nav">
      <div className="nav-inner">
        <Link to="/" className="nav-brand">
          <span className="brand-icon">◆</span>
          <span className="brand-text">Grade My Government</span>
        </Link>
        <div className="nav-links">
          <Link to="/" className={isActive('/')}>Country Lookup</Link>
          <Link to="/rankings" className={isActive('/rankings')}>Rankings</Link>
          <Link to="/methodology" className={isActive('/methodology')}>Methodology</Link>
          <Link to="/suggest" className={isActive('/suggest')}>Suggest Data</Link>
          <Link to="/simulation" className={isActive('/simulation')}>Simulations</Link>
        </div>
      </div>
    </nav>
  );
}

function Footer() {
  return (
    <footer className="main-footer">
      <div className="footer-inner">
        <div className="footer-left">
          <p className="footer-title">Grade My Government</p>
          <p className="footer-subtitle">
            Companion to <em>Macro-Governance Theory: A Quantitative Framework for Measuring and Enhancing Jurisdictional Wellbeing</em>
          </p>
        </div>
        <div className="footer-right">
          <p>This tool is non-political and purely data-driven.</p>
          <p>All data sourced from publicly available databases.</p>
          <p className="footer-sources">
            Sources: World Bank WDI, UNESCO, ILO, WHO/UNICEF, Swiss Re, BIS
          </p>
        </div>
      </div>
    </footer>
  );
}

function App() {
  return (
    <Router>
      <div className="app">
        <NavBar />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<CountryLookup />} />
            <Route path="/rankings" element={<RankingsPage />} />
            <Route path="/simulation" element={<SimulationPage />} />
            <Route path="/methodology" element={<MethodologyPage />} />
            <Route path="/suggest" element={<SuggestDataPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
